module.exports = __webpack_public_path__ + "images/issue-type-to-check.20c0325369e9f8f049d4044538173e9a.png";